import ContentLoader from "react-content-loader";
import { useMediaQuery } from "react-responsive";
import { Color } from "../../enums/Color";
import { merge } from "react-merge";

const styles = {
    mobile: {
        wrapper: {
            marginTop: "5.79vw"
        },
        card: {
            width: "100%",
            height: "424.15vw",
            backgroundColor: Color.White
        }
    },
    desktop: {
        wrapper: {
            marginTop: "1.61vw"
        },
        card: {
            width: "100%",
            height: "37.27vw",
            backgroundColor: Color.White
        }
    }
};

export const StatisticsLoader: React.FC = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    var loaderStyles = styles.mobile;

    if (!isMobile) {
        let extendStyles = merge(styles.mobile, styles.desktop);
        loaderStyles = extendStyles;
    }

    return (
        <div style={loaderStyles.wrapper}>
            <div style={loaderStyles.card}>
                <ContentLoader
                    speed={1}
                    width={"100%"}
                    height={loaderStyles.card.height}
                    backgroundColor={Color.LoaderBackground}
                    foregroundColor={Color.LoaderForeground}
                >
                    {isMobile ? <>
                        <rect x="0%" y="0%" rx="10" ry="10" width="100%" height="8%"/>
                        <rect x="0%" y="9%" rx="10" ry="10" width="49%" height="19.5%"/>
                        <rect x="51%" y="9%" rx="10" ry="10" width="49%" height="19.5%"/>
                        <rect x="0%" y="31.55%" rx="10" ry="10" width="100%" height="25.78%"/>
                        <rect x="0%" y="60.45%" rx="3" ry="3" width="100%" height="38.57%"/>
                    </> :
                    <>
                        <rect x="0%" y="0%" rx="5" ry="5" width="18.97%" height="19.23%"/>
                        <rect x="20.72%" y="0%" rx="5" ry="5" width="38.97%" height="19.43%"/>
                        <rect x="60.92%" y="0%" rx="5" ry="5" width="38.97%" height="19.43%"/>
                        <rect x="0%" y="25.7%" rx="0" ry="0" width="64.67%" height="68.63%"/>
                        <rect x="67.92%" y="25.7%" rx="5" ry="5" width="31.54%" height="73.63%"/>
                    </>}                     
                </ContentLoader>
            </div>
        </div>
    );
}